import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import VehicleDetailSteps from '../components/VehicleDetailSteps'

const SchatzpreisPage = () => {
  const location = useLocation()
  const vehicle = location.state?.vehicle || {}
  const estimate = location.state?.estimate || {}
  const vehicleSummary =
    location.state?.vehicleSummary ||
    [
      vehicle.make || vehicle.brand,
      vehicle.model,
      vehicle.year,
      vehicle.trim,
      vehicle.engine,
      vehicle.transmission,
    ]
      .filter(Boolean)
      .join(', ')
  const amountRaw = estimate.amount ?? estimate.value
  const amount = amountRaw !== undefined && amountRaw !== null && !Number.isNaN(Number(amountRaw)) ? Number(amountRaw) : null
  const formattedEstimate = amount !== null ? `${amount.toLocaleString('de-DE')} EUR` : 'Preis folgt'
  return (
    <div className="bg-[#f3f4f8] text-gray-800 min-h-screen">
      <header className="w-full shadow-sm bg-[#9800B3]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center">
          <Link to="/" className="flex items-center">
            <img src="/images/Logo.svg" alt="autoverkaufen.de" className="h-8 w-auto" />
          </Link>
        </div>
      </header>

      <main>
        <section className="bg-gradient-to-b from-[#f8f5fb] via-[#f3f4f8] to-[#f3f4f8]">
          <div className="max-w-6xl mx-auto px-4 pt-8 md:pt-10 pb-4 md:pb-6 space-y-6">
            <div className="bg-white rounded-[32px] shadow-[0_35px_60px_-30px_rgba(28,24,77,0.3)] border border-gray-200 p-6 md:p-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
              <div className="space-y-3">
                <h1 className="text-2xl md:text-4xl font-black text-brand-fuchsia leading-tight">Schaetzpreis</h1>
                <p className="text-gray-700 text-base md:text-lg max-w-3xl leading-relaxed">Dein Schaetzpreis basiert auf deinen bisherigen Angaben und gibt dir eine erste, ehrliche Orientierung. Wir pruefen jedes Auto individuell - der finale Preis kann sich mit weiteren Infos noch veraendern.</p>
              </div>
              <div className="bg-[#f8f7fb] rounded-2xl border border-gray-200 p-5 w-full md:w-[360px]">
                <p className="text-xs uppercase tracking-wide text-gray-500 mb-2">Dein Auto</p>
                <p className="font-medium text-base text-gray-900 leading-snug mb-4">{vehicleSummary || 'Dein Fahrzeug'}</p>
                <div className="flex items-end justify-between">
                  <span className="text-sm text-gray-500">Schaetzpreis</span>
                  <span className="text-3xl md:text-5xl font-black text-brand-fuchsia">{formattedEstimate}</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-4 md:pt-6 pb-10 md:pb-12">
          <div className="max-w-6xl mx-auto space-y-6">
            <div className="px-4 space-y-2">
              <h2 className="text-2xl font-bold text-gray-900 leading-tight">Fahrzeugdetails ergaenzen und Bestpreis erhalten</h2>
              <p className="text-gray-700 leading-relaxed text-base">Fuer einen genaueren Bestpreis brauchen wir noch ein paar Details und Fotos. Damit bewerten wir dein Auto praezise und transparent. Deine Angaben bleiben vertraulich und dienen nur der Preisermittlung.</p>
            </div>
            <div style={{ paddingLeft: '0.4rem', paddingRight: '0.4rem' }}>
              <VehicleDetailSteps className="mt-2" defaultOpen={1} />
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-gray-900 text-gray-200 py-8">
        <div className="max-w-6xl mx-auto px-4 grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
          <Link to="/faq" className="hover:text-white">
            Häufige Fragen
          </Link>
          <a href="#" className="hover:text-white">
            Kontakt
          </a>
          <Link to="/datenschutz" className="hover:text-white">
            Datenschutz
          </Link>
          <Link to="/impressum" className="hover:text-white">
            Impressum
          </Link>
          <Link to="/allgemeine-nutzungsbedingungen" className="hover:text-white">
            Allgemeine Nutzungsbedingungen
          </Link>
        </div>
      </footer>
    </div>
  )
}

export default SchatzpreisPage
